import { useAnalyticsData } from "modules/customerTickets/hooks/useAnalyticsData";
import React, { FC } from "react";
import { StyledDataGrid } from "shared/components/TableWithPagination/styled";
import { getComparingSectionColumns } from "./helpers";

const ComparingSection: FC = () => {
  const { inquiriesByCategory } = useAnalyticsData();

  const rows = inquiriesByCategory.map((item, idx) => ({
    ...item,
    id: idx + 1,
  }));

  const columns = getComparingSectionColumns();

  return (
    <div style={{ width: "100%" }}>
      <StyledDataGrid
        autoHeight
        rows={rows}
        columns={columns}
        disableColumnMenu
        hideFooter
        rowHeight={60}
        disableRowSelectionOnClick
      />
    </div>
  );
};

export default ComparingSection;
